import { render, staticRenderFns } from "./HeaderElem.vue?vue&type=template&id=47f415c4"
import script from "./HeaderElem.vue?vue&type=script&lang=js"
export * from "./HeaderElem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports